import { render, staticRenderFns } from "./MessengerIcon.vue?vue&type=template&id=18cb2753"
import script from "./MessengerIcon.vue?vue&type=script&lang=js"
export * from "./MessengerIcon.vue?vue&type=script&lang=js"
import style0 from "./MessengerIcon.vue?vue&type=style&index=0&id=18cb2753&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports